export const disableFutureDates = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, 0);
    const year = now.getUTCFullYear();
    const day = String(now.getDate()).padStart(2, 0);
    return `${year}-${month}-${day}`;
}